export default __webpack_public_path__ + "static/media/img_olimpiad_vsesib.ad6c7abf.png";